import React from 'react'
import styled from 'styled-components'
import { font, ink, line, radius, shadow, surface, transition } from 'features/dashboard/tokens'

const LEVELS = [
  { key: 'portfolio', label: 'Portfolios' },
  { key: 'estate', label: 'Estates' },
  { key: 'bp', label: 'Building Passports' },
  { key: 'unit', label: 'Units' },
]

const LevelTabs = ({ counts = {}, active = 'portfolio', onSelect, loading = false }) => (
  <Bar role='tablist' aria-label='Level' aria-busy={loading}>
    {LEVELS.map(l => {
      const selected = active === l.key
      const count = counts[l.key] ?? 0
      return (
        <Tab
          key={l.key}
          type='button'
          role='tab'
          aria-selected={selected}
          $selected={selected}
          disabled={loading}
          onClick={() => !loading && onSelect && onSelect(l.key)}
        >
          {l.label}
          <Count $selected={selected}>{loading ? '·' : count.toLocaleString()}</Count>
        </Tab>
      )
    })}
  </Bar>
)

export default LevelTabs

const Bar = styled.div`
  display: inline-flex;
  max-width: 100%;
  background: ${surface.wash};
  border: 1px solid ${line.base};
  border-radius: ${radius.md};
  padding: 5px;
  gap: 3px;

  @media (max-width: 768px) {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }
`

const Tab = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  white-space: nowrap;
  border: 0;
  background: ${({ $selected }) => ($selected ? surface.card : 'transparent')};
  color: ${({ $selected, theme }) => ($selected ? theme.colors.secondary : ink.mute)};
  box-shadow: ${({ $selected }) => ($selected ? shadow.card : 'none')};
  font: inherit;
  font-weight: 700;
  font-size: ${font.body};
  padding: 9px 15px;
  border-radius: ${radius.sm};
  cursor: pointer;
  transition: ${transition};

  &:hover {
    color: ${({ $selected, theme }) => ($selected ? theme.colors.secondary : ink.base)};
  }
  &:disabled { cursor: default; }
`

const Count = styled.span`
  font-size: ${font.caption};
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  padding: 1px 8px;
  border-radius: ${radius.pill};
  color: ${({ $selected }) => ($selected ? '#fff' : ink.mute)};
  background: ${({ $selected, theme }) => ($selected ? theme.colors.secondary : surface.card)};
  border: 1px solid ${({ $selected, theme }) => ($selected ? theme.colors.secondary : line.base)};
`
